export const ESRI = 'esri';
export const GIS = 'gis';
export const GOOGLE = 'google';
export const RSOS = 'rsos';
